import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { getInteractiveHeaderReportsAPIConfig } from './interactive-header.api';
import {
    convertReportResultsToBoards,
    getInitialStateForBoards,
    getLoadingStateForBoards,
} from './interactive-header.utils';

export const UPDATE_CURRENT_BOARD = '@navigation/interactive-header/UPDATE_CURRENT_BOARD';

export const GET_REPORTS_REQUEST_CALLED = '@navigation/interactive-header/GET_REPORTS_REQUEST_CALLED';
export const GET_REPORTS_REQUEST_STARTED = '@navigation/interactive-header/GET_REPORTS_REQUEST_STARTED';
export const GET_REPORTS_REQUEST_SUCCEEDED = '@navigation/interactive-header/GET_REPORTS_REQUEST_SUCCEEDED';
export const GET_REPORTS_REQUEST_FAILED = '@navigation/interactive-header/GET_REPORTS_REQUEST_FAILED';

export const getReports = ({ entityType, entityId }) => ({
    type: GET_REPORTS_REQUEST_CALLED,
    actionTypes: {
        start: GET_REPORTS_REQUEST_STARTED,
        success: GET_REPORTS_REQUEST_SUCCEEDED,
        fail: GET_REPORTS_REQUEST_FAILED,
    },
    config: getInteractiveHeaderReportsAPIConfig({ entityType, entityId }),
});

export const updateCurrentBoard = name => ({
    type: UPDATE_CURRENT_BOARD,
    payload: { name },
});

const initialState = {
    currentBoard: null,
    loadingState: {
        THIS_MONTH_METRICS: true,
        THIS_DAY_LEADER_BOARD: true,
        THIS_WEEK_LEADER_BOARD: true,
        THIS_MONTH_LEADER_BOARD: true,
        THIS_QUARTER_LEADER_BOARD: true,
        THIS_YEAR_APPLIED_SAVINGS: true,
        LAST_12_MONTHS_APPLIED_SAVINGS: true,
        THIS_DAY_POTENTIAL_SAVINGS: true,
        ALL_TIME_GAMIFICATION_ECONOMIES: true,
    },
    boards: {
        THIS_MONTH_METRICS: [],
        THIS_DAY_LEADER_BOARD: [],
        THIS_WEEK_LEADER_BOARD: [],
        THIS_MONTH_LEADER_BOARD: [],
        THIS_QUARTER_LEADER_BOARD: [],
        THIS_YEAR_APPLIED_SAVINGS: [],
        LAST_12_MONTHS_APPLIED_SAVINGS: [],
        THIS_DAY_POTENTIAL_SAVINGS: [],
        ALL_TIME_GAMIFICATION_ECONOMIES: [],
    },
};

export const interactiveHeaderReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [UPDATE_CURRENT_BOARD]: (state, action) => ({
        ...state,
        currentBoard: action.payload.name,
    }),
    [GET_REPORTS_REQUEST_CALLED]: state => ({
        ...state,
        currentBoard: initialState.currentBoard,
        loadingState: initialState.loadingState,
        boards: initialState.boards,
    }),
    [GET_REPORTS_REQUEST_STARTED]: (state, action) => ({
        ...state,
        loadingState: {
            ...state.loadingState,
            ...getLoadingStateForBoards(state.loadingState, action.requestConfig, true),
        },
    }),
    [GET_REPORTS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadingState: {
            ...state.loadingState,
            ...getLoadingStateForBoards(state.loadingState, action.requestConfig, false),
        },
        boards: {
            ...state.boards,
            ...convertReportResultsToBoards(action.payload.data),
        },
    }),
    [GET_REPORTS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadingState: {
            ...state.loadingState,
            ...getLoadingStateForBoards(state.loadingState, action.requestConfig, false),
        },
        boards: {
            ...state.boards,
            ...getInitialStateForBoards(initialState, action.requestConfig),
        },
    }),
});
